import {
  FETCH_CARE_ROUND,
  FETCH_CARE_ROUND_SUCCESS,
  FETCH_CARE_ROUND_FAILURE,
  ADD_CARE_ROUND,
  ADD_CARE_ROUND_SUCCESS,
  ADD_CARE_ROUND_FAILURE,
  FETCH_CARE_ROUND_ITEM,
  FETCH_CARE_ROUND_ITEM_SUCCESS,
  FETCH_CARE_ROUND_ITEM_FAILURE,
  EDIT_CARE_ROUND,
  EDIT_CARE_ROUND_SUCCESS,
  EDIT_CARE_ROUND_FAILURE,
  DELETE_CARE_ROUND,
  DELETE_CARE_ROUND_SUCCESS,
  DELETE_CARE_ROUND_FAILURE,
  SET_CARE_ROUND_ADD_EDIT_MODAL,
} from "./constants";

export const fetchCareRound = (payload) => ({
  type: FETCH_CARE_ROUND,
  payload,
});
export const fetchCareRoundSuccess = (payload) => ({
  type: FETCH_CARE_ROUND_SUCCESS,
  payload,
});
export const fetchCareRoundFailure = (payload) => ({
  type: FETCH_CARE_ROUND_FAILURE,
  payload,
});

export const addCareRound = (payload) => ({
  type: ADD_CARE_ROUND,
  payload,
});
export const addCareRoundSuccess = (payload) => ({
  type: ADD_CARE_ROUND_SUCCESS,
  payload,
});
export const addCareRoundFailure = (payload) => ({
  type: ADD_CARE_ROUND_FAILURE,
  payload,
});

export const fetchCareRoundItem = (payload) => ({
  type: FETCH_CARE_ROUND_ITEM,
  payload,
});
export const fetchCareRoundItemSuccess = (payload) => ({
  type: FETCH_CARE_ROUND_ITEM_SUCCESS,
  payload,
});
export const fetchCareRoundItemFailure = (payload) => ({
  type: FETCH_CARE_ROUND_ITEM_FAILURE,
  payload,
});

export const editCareRound = (payload) => ({
  type: EDIT_CARE_ROUND,
  payload,
});
export const editCareRoundSuccess = (payload) => ({
  type: EDIT_CARE_ROUND_SUCCESS,
  payload,
});
export const editCareRoundFailure = (payload) => ({
  type: EDIT_CARE_ROUND_FAILURE,
  payload,
});

export const deleteCareRound = (payload, onDelete) => ({
  type: DELETE_CARE_ROUND,
  payload,
  onDelete,
});
export const deleteCareRoundSuccess = (payload) => ({
  type: DELETE_CARE_ROUND_SUCCESS,
  payload,
});
export const deleteCareRoundFailure = (payload) => ({
  type: DELETE_CARE_ROUND_FAILURE,
  payload,
});

export const setCareRoundAddEditModal = (payload) => ({
  type: SET_CARE_ROUND_ADD_EDIT_MODAL,
  payload,
});
